const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const fetchPaymentById = async (leadId, paymentId) => {
    const token = localStorage.getItem('token');
    try {



        const response = await fetch(`${API_BASE_URL}/admin/lead/leads/payments/${paymentId}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });
        if (!response.ok) {
            const errorData = await response.json();
            const errorMessage = errorData.message || `Ошибка HTTP! Статус: ${response.status}. Не удалось получить данные платежа.`;
            throw new Error(errorMessage);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Ошибка при получении платежа по ID:', error);
        if (error.message.startsWith('Ошибка HTTP!')) {
            throw error; 
        } else {
            throw new Error('Произошла непредвиденная ошибка при загрузке платежа. Пожалуйста, попробуйте еще раз.');
        }
    }
};